import serviceConfig from './service-config';

export default {
  serviceConfig,
};
